// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plant-box_PlantBox__ydHxq {
    width: 20%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.plant-box_PlantBox__ydHxq div {
    width: 62px;
    height: 110px;
    overflow: hidden;
    border-radius: 100px;
    border: 1px solid #D6E5B8;
    margin-bottom: 8px !important;
}

.plant-box_PlantBox__ydHxq p {
    font-size: 10px;
    color: #FFFFFF;
    text-align: center !important;
    font-family: 'Century Gothic';
}

@media (min-width: 1200px) {
    .plant-box_PlantsBox__42cA9 {
        gap: 14px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .plant-box_PlantBox__ydHxq {
        margin: 0;
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        flex-direction: column;
    }

    .plant-box_PlantBox__ydHxq div {
        width: 200px;
        height: 356px;
        margin-bottom: 30px !important;
    }

    .plant-box_PlantBox__ydHxq p {
        font-size: 25px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/plant-box/plant-box.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI;QACI,SAAS;QACT,aAAa;QACb,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,SAAS;QACT,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".PlantBox {\r\n    width: 20%;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.PlantBox div {\r\n    width: 62px;\r\n    height: 110px;\r\n    overflow: hidden;\r\n    border-radius: 100px;\r\n    border: 1px solid #D6E5B8;\r\n    margin-bottom: 8px !important;\r\n}\r\n\r\n.PlantBox p {\r\n    font-size: 10px;\r\n    color: #FFFFFF;\r\n    text-align: center !important;\r\n    font-family: 'Century Gothic';\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .PlantsBox {\r\n        gap: 14px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .PlantBox {\r\n        margin: 0;\r\n        display: flex;\r\n        flex: 0 0 auto;\r\n        align-items: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .PlantBox div {\r\n        width: 200px;\r\n        height: 356px;\r\n        margin-bottom: 30px !important;\r\n    }\r\n\r\n    .PlantBox p {\r\n        font-size: 25px;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PlantBox": `plant-box_PlantBox__ydHxq`,
	"PlantsBox": `plant-box_PlantsBox__42cA9`
};
export default ___CSS_LOADER_EXPORT___;
